/* Undefined Nutrition product page behaviour (sections/un-pdp-*.liquid). Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function store(n) { return window.Alpine && typeof Alpine.store === 'function' ? Alpine.store(n) : null; }

  /* ---------- Cart ---------- */
  // items: [{ id, quantity, selling_plan?, properties? }]
  function plainAdd(items) {
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) return { ok: false, message: (j && (j.description || j.message)) || '' };
        document.dispatchEvent(new CustomEvent('eurus:cart:reload'));
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        return { ok: true, res: j };
      });
    });
  }
  // Same path Arise uses in assets/product-cart.js, so the cart drawer and count update.
  function themeAdd(items) {
    var H = store('xCartHelper');
    if (!H || typeof H.withCartLock !== 'function') return plainAdd(items);
    var fd = new FormData();
    fd.append('form_type', 'product');
    fd.append('utf8', '✓');
    items.forEach(function (it, i) {
      var b = 'items[' + i + ']';
      fd.append(b + '[id]', it.id);
      fd.append(b + '[quantity]', it.quantity);
      if (it.selling_plan) fd.append(b + '[selling_plan]', it.selling_plan);
      if (it.properties) Object.keys(it.properties).forEach(function (k) { fd.append(b + '[properties][' + k + ']', it.properties[k]); });
    });
    try { fd.append('sections', H.getSectionsToRender().map(function (s) { return s.id; })); } catch (e) {}
    fd.append('sections_url', window.location.pathname);
    var url = (window.Eurus && Eurus.cart_add_url) || (ROOT_URL + 'cart/add');
    var lines = [];
    try { lines = H.addLines(fd); } catch (e) {}
    return H.withCartLock(function (standardEvent) {
      return fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return H.cartJson(r); })
        .then(function (res) {
          if (String(res.status) === '422') {
            document.dispatchEvent(new CustomEvent('eurus:product:add-failed', { detail: { errorMessage: res.description } }));
            var mini = store('xMiniCart');
            if (mini && typeof mini.reLoad === 'function') { mini.reLoad(); document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); }
            return H.settleWithCart(standardEvent, H.userErrorsFrom(res)).then(function () { return { ok: false, message: res.description || res.message || '' }; });
          }
          if (res.sections) H.reRenderSections(res.sections);
          var noti = store('xCartNoti');
          if (noti && noti.enable && typeof noti.setItem === 'function') { noti.setItem(res); }
          else { var cart = store('xMiniCart'); if (cart && typeof cart.openCart === 'function') cart.openCart(); }
          var bubble = document.getElementById('cart-icon-bubble');
          var count = bubble ? parseInt(bubble.innerHTML, 10) : NaN;
          if (!isNaN(count)) H.currentItemCount = count;
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: res } }));
          return H.settleWithCart(standardEvent).then(function () { return { ok: true, res: res }; });
        });
    }, { type: 'shopify:cart:lines-update', action: 'add', context: 'product', lines: lines });
  }
  function addItems(items) {
    return Promise.resolve().then(function () { return themeAdd(items); }).catch(function () { return plainAdd(items); });
  }
  window.UNP = window.UNP || {};
  window.UNP.add = addItems;

  /* ---------- Helpers ---------- */
  function money(cents, fmt) {
    var f = (fmt || '${{amount}}');
    var n = (Number(cents) || 0) / 100;
    function num(v, dec, th, ds) {
      var s = v.toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.join(ds);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(n, 0, ',', '.');
        case 'amount_with_comma_separator': return num(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(n, 2, "'", '.');
        default: return num(n, 2, ',', '.');
      }
    });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function uid() { return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function tokens(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/).filter(function (w) { return w.length >= 3; });
  }

  /* ---------- Supplement facts: swipe through every label; the selected flavor's label comes into view ---------- */
  var lastLabel = null;
  function matchLabel(items, title) {
    var ts = tokens(title), key = String(title || '').toLowerCase(), best = 0, bi = -1;
    items.forEach(function (it, i) {
      if (best === 99) return;
      if (String(it.getAttribute('data-name') || '').toLowerCase() === key) { best = 99; bi = i; return; }
      var f = String(it.getAttribute('data-f') || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      var sc = 0;
      ts.forEach(function (w) { if (f.indexOf(w.slice(0, 4)) > -1) sc++; });
      if (sc > best) { best = sc; bi = i; }
    });
    return bi;
  }
  function initLabels(scope) {
    (scope || document).querySelectorAll('[data-unp-fls]').forEach(function (box) {
      if (box.__unp) return;
      box.__unp = true;
      var track = box.querySelector('[data-unp-fl-track]');
      var items = track ? Array.prototype.slice.call(track.querySelectorAll('[data-unp-fl]')) : [];
      if (items.length < 2) return;
      var cap = box.querySelector('[data-unp-fl-cap]'), cnt = box.querySelector('[data-unp-fl-count]');
      var prev = box.querySelector('[data-unp-fl-prev]'), next = box.querySelector('[data-unp-fl-next]');
      var at = 0, raf = 0, want = -1;
      function set(i) {
        at = i;
        var nm = items[i].getAttribute('data-name');
        if (cap) cap.textContent = nm || 'Label ' + (i + 1) + ' of ' + items.length;
        if (cnt) cnt.textContent = pad(i + 1) + ' / ' + pad(items.length);
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= items.length - 1;
      }
      function go(i, instant) {
        i = Math.max(0, Math.min(items.length - 1, i));
        want = i;
        track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
        set(i);
      }
      // Labels lazy-load, so the track may not be scrollable yet when the flavor is first matched.
      // Re-apply the jump as images arrive, until the shopper touches the track.
      function settle() {
        if (want < 0) return;
        var l = items[want].offsetLeft - items[0].offsetLeft;
        if (Math.abs(track.scrollLeft - l) > 2) track.scrollTo({ left: l, behavior: 'auto' });
        else want = -1;
      }
      track.addEventListener('load', settle, true);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        track.addEventListener(ev, function () { want = -1; }, { passive: true });
      });
      box.__unpItems = items;
      box.__unpGo = go;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          i = Math.max(0, Math.min(items.length - 1, i));
          if (i !== at) set(i);
        });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(at - 1); });
      if (next) next.addEventListener('click', function () { go(at + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1); }
      });
      window.addEventListener('resize', function () { go(at, true); });
      set(0);
      if (lastLabel !== null) { var mi = matchLabel(items, lastLabel); if (mi > -1) go(mi, true); }
    });
  }
  // Runs on every buy box render; only moves the labels when the selected flavor changes,
  // so a shopper who swiped to another label is not pulled back by a quantity or plan change.
  function syncLabels(title) {
    if (title === lastLabel) return;
    var first = lastLabel === null;
    lastLabel = title;
    document.querySelectorAll('[data-unp-fls]').forEach(function (box) {
      if (!box.__unpGo) return;
      var i = matchLabel(box.__unpItems, title);
      if (i > -1) box.__unpGo(i, first);
    });
  }

  /* ---------- Main buy box ---------- */
  function initMain(root) {
    if (!root || root.__unp) return;
    root.__unp = true;
    var D;
    try { D = JSON.parse(root.querySelector('[data-unp-json]').textContent); } catch (e) { return; }
    var V = D.variants || [], PL = D.plans || [];
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var SW = {};
    String(D.sw || '').split(/\r?\n/).forEach(function (l) {
      var i = l.lastIndexOf(':');
      if (i > 0) SW[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim();
    });
    function sw(t) { return SW[String(t || '').toLowerCase()] || ''; }

    var tierBtns = qa('[data-unp-tier]');
    var chips = qa('[data-unp-chip]');
    var planBtns = qa('[data-unp-plan]');
    var hasTiers = tierBtns.length === 3;
    var multiV = V.length > 1;
    var S = {
      tier: 0, slot: 0, plan: 0, qty: 1, slide: 0,
      picks: [D.v0 || 0, D.v0 || 0, D.v0 || 0],
      buy: PL.length && D.buy === 'subscribe' ? 'subscribe' : 'onetime'
    };
    function N() { return hasTiers ? S.tier + 1 : 1; }
    function picks() { return S.picks.slice(0, N()); }
    function slot() { return Math.min(S.slot, N() - 1); }
    function cur() { return V[picks()[slot()]] || V[0]; }
    function tierPct(i) { return Number((D.tiers || [])[i]) || 0; }
    function isSub() { return S.buy === 'subscribe' && PL.length > 0; }
    function subPrice(v) {
      var pl = PL[S.plan];
      if (pl && v.sp && v.sp[String(pl.id)] != null) return v.sp[String(pl.id)];
      return v.p;
    }
    function totals() {
      var t = hasTiers ? tierPct(S.tier) : 0, qty = hasTiers ? 1 : S.qty;
      var o = { once: 0, sub: 0, cmp: 0 };
      picks().forEach(function (i) {
        var v = V[i];
        o.once += Math.round(v.p * (1 - t / 100)) * qty;
        o.sub += Math.round(subPrice(v) * (1 - t / 100)) * qty;
        o.cmp += Math.max(v.c || 0, v.p) * qty;
      });
      o.total = isSub() ? o.sub : o.once;
      return o;
    }
    function planPct(pi) {
      var v = cur(), pl = PL[pi];
      if (!pl || !v.sp || v.sp[String(pl.id)] == null || !v.p) return 0;
      return Math.round((1 - v.sp[String(pl.id)] / v.p) * 100);
    }
    function allOk() { return picks().every(function (i) { return V[i] && V[i].ok; }); }
    function fm(c) { return money(c, D.money); }

    /* Gallery */
    var track = q('[data-unp-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-unp-slide]')) : [];
    var heroImg = q('[data-unp-hero]');
    var thumbsBox = q('[data-unp-thumbs]');
    var thumbs = [];
    if (thumbsBox && slides.length > 1) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'unp-thumb';
        b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
        var im = document.createElement('img');
        im.src = s.getAttribute('data-thumb') || ''; im.alt = ''; im.loading = 'lazy'; im.width = 68; im.height = 84;
        if (i === 0) im.setAttribute('data-unp-thumb0', '');
        b.appendChild(im);
        b.addEventListener('click', function () { go(i); });
        thumbsBox.appendChild(b); thumbs.push(b);
      });
      thumbsBox.hidden = false;
    }
    slides.forEach(function (s, i) { s.setAttribute('aria-label', (i + 1) + ' of ' + slides.length); });
    var countEl = q('[data-unp-count]'), prevB = q('[data-unp-prev]'), nextB = q('[data-unp-next]');
    function setSlide(i) {
      S.slide = i;
      if (countEl) countEl.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prevB) prevB.disabled = i <= 0;
      if (nextB) nextB.disabled = i >= slides.length - 1;
    }
    function go(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = Math.min(slides[i].offsetLeft, track.scrollWidth - track.clientWidth);
      track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      setSlide(i);
    }
    var raf = 0;
    if (track) track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (slides.length < 2) return;
        var step = slides[1].offsetLeft - slides[0].offsetLeft || 1;
        var i = Math.round(track.scrollLeft / step);
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) i = slides.length - 1;
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== S.slide) setSlide(i);
      });
    }, { passive: true });
    if (prevB) prevB.addEventListener('click', function () { go(S.slide - 1); });
    if (nextB) nextB.addEventListener('click', function () { go(S.slide + 1); });
    if (track) track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(S.slide - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(S.slide + 1); }
    });
    setSlide(0);

    function showHero(v) {
      if (!v || !v.img) return;
      if (heroImg && heroImg.getAttribute('src') !== v.img) {
        heroImg.removeAttribute('srcset'); heroImg.removeAttribute('sizes');
        heroImg.src = v.img; heroImg.alt = D.name + ', ' + v.t;
      }
      var t0 = thumbsBox && thumbsBox.querySelector('[data-unp-thumb0]');
      if (t0 && v.th) t0.src = v.th;
      var st = q('[data-unp-sticky-img]');
      if (st && v.th) { st.removeAttribute('srcset'); st.removeAttribute('sizes'); st.src = v.th; }
    }

    /* Header height for the gallery height formula */
    function headerH() {
      var m = document.getElementById('MainContent');
      if (!m) return;
      var t = m.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--unp-hh', Math.max(0, Math.min(t, 240)) + 'px');
    }
    headerH();

    /* Desktop: the buy card stays in view while the gallery and highlights scroll past, and stops
       above the next section (its bottom margin keeps a gap). It sits under the sticky header; a card
       taller than the screen scrolls until its bottom is visible, then holds there. */
    var card = q('.unp-card');
    function stickTop() {
      if (!card) return;
      var hh = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) {
        var pos = getComputedStyle(s).position;
        if (pos === 'sticky' || pos === 'fixed') hh = Math.max(hh, s.offsetHeight);
      });
      var t = Math.min(hh + 16, window.innerHeight - card.offsetHeight - 16);
      root.style.setProperty('--unp-st', Math.round(t) + 'px');
    }
    stickTop();
    window.addEventListener('resize', stickTop);
    if (card && 'ResizeObserver' in window) new ResizeObserver(stickTop).observe(card);

    /* Render */
    var el = {
      price: q('[data-unp-price]'), compare: q('[data-unp-compare]'), save: q('[data-unp-save]'),
      optlbl: q('[data-unp-optlbl]'), optname: q('[data-unp-optname]'), mix: q('[data-unp-mixnote]'), slots: q('[data-unp-slots]'),
      once: q('[data-unp-ponce]'), sub: q('[data-unp-psub]'), subpct: q('[data-unp-subpct]'), subbox: q('[data-unp-subbox]'), freq: q('[data-unp-freq]'),
      add: q('[data-unp-add]'), buy: q('[data-unp-buy]'), msg: q('[data-unp-msg]'), id: q('[data-unp-id]'), qty: q('[data-unp-qtyin]'),
      sticky: q('[data-unp-sticky]'), stickySub: q('[data-unp-sticky-sub]'), stickyAdd: q('[data-unp-sticky-add]')
    };
    var busy = false, addedT = 0, added = false;
    var unitL = String(D.unit || 'Tub');

    function mixText() {
      var pk = picks(), order = [];
      pk.forEach(function (x) { if (order.indexOf(x) < 0) order.push(x); });
      if (pk.length === 1) return V[pk[0]].t;
      return order.map(function (x) { return pk.filter(function (y) { return y === x; }).length + '× ' + V[x].t; }).join(', ');
    }

    function render() {
      var n = N(), sl = slot(), v = cur(), T = totals();

      // Tiers
      tierBtns.forEach(function (b, i) {
        var pct = tierPct(i), cnt = i + 1;
        b.setAttribute('aria-pressed', i === S.tier ? 'true' : 'false');
        var per = b.querySelector('[data-unp-per]');
        if (per) per.textContent = fm(Math.round(v.p * (1 - pct / 100))) + ' / ' + unitL.toLowerCase();
        var sv = b.querySelector('[data-unp-tsave]');
        if (sv) {
          if (pct > 0) { sv.textContent = 'Save ' + pct + '%'; sv.classList.add('is-red'); }
          else {
            sv.classList.remove('is-red');
            sv.textContent = cnt === 1 ? 'Standard' : (multiV ? 'Mix ' + String(D.opt || 'flavor').toLowerCase() + 's' : fm(v.p * cnt) + ' total');
          }
        }
        var tag = b.querySelector('[data-unp-tag]');
        if (tag) tag.hidden = !(i === 2 && tierPct(2) > 0 && tierPct(2) > tierPct(1));
      });

      // Options
      if (el.optlbl) el.optlbl.textContent = n > 1 && multiV ? unitL + ' ' + (sl + 1) + ' ' + String(D.opt || '').toLowerCase() : D.opt;
      if (el.optname) el.optname.textContent = v.t;
      if (el.mix) el.mix.hidden = !(n > 1 && multiV);
      if (el.slots) {
        if (n > 1 && multiV) {
          el.slots.hidden = false;
          el.slots.innerHTML = '';
          picks().forEach(function (vi, j) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'unp-slot';
            b.setAttribute('aria-pressed', j === sl ? 'true' : 'false');
            b.setAttribute('aria-label', unitL + ' ' + (j + 1) + ': ' + V[vi].t);
            var a = document.createElement('span'); a.className = 'unp-slot-n'; a.textContent = unitL + ' ' + (j + 1);
            var row = document.createElement('span'); row.className = 'unp-slot-v';
            var dot = document.createElement('span'); dot.className = 'unp-sw'; dot.setAttribute('aria-hidden', 'true');
            var c = sw(V[vi].t); if (c) dot.style.setProperty('--sw', c);
            var nm = document.createElement('span'); nm.className = 'unp-slot-name'; nm.textContent = V[vi].t;
            row.appendChild(dot); row.appendChild(nm); b.appendChild(a); b.appendChild(row);
            b.addEventListener('click', function () { S.slot = j; showHero(V[vi]); go(0, true); render(); });
            el.slots.appendChild(b);
          });
        } else { el.slots.hidden = true; el.slots.innerHTML = ''; }
      }
      chips.forEach(function (b) {
        var i = Number(b.getAttribute('data-unp-chip'));
        b.setAttribute('aria-pressed', i === picks()[sl] ? 'true' : 'false');
        var cnt = b.querySelector('[data-unp-cnt]');
        if (cnt) {
          var k = picks().filter(function (x) { return x === i; }).length;
          cnt.hidden = !(n > 1 && k > 0);
          cnt.textContent = '×' + k;
        }
      });

      // Purchase options
      if (el.once) el.once.textContent = fm(T.once);
      if (el.sub) el.sub.textContent = fm(T.sub);
      if (el.subpct) { var pp = planPct(S.plan); el.subpct.textContent = pp > 0 ? pp + '%' : ''; }
      qa('[data-unp-pt]').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-unp-pt') === S.buy ? 'true' : 'false');
      });
      if (el.subbox) el.subbox.classList.toggle('is-on', isSub());
      if (el.freq) el.freq.hidden = !isSub();
      planBtns.forEach(function (b) {
        var i = Number(b.getAttribute('data-unp-plan'));
        b.setAttribute('aria-pressed', i === S.plan ? 'true' : 'false');
      });

      // Price
      if (el.price) el.price.textContent = fm(T.total);
      var showCmp = T.total < T.cmp - 1;
      if (el.compare) { el.compare.hidden = !showCmp; el.compare.textContent = fm(T.cmp); }
      if (el.save) {
        el.save.hidden = !showCmp;
        el.save.textContent = 'Save ' + Math.round((1 - T.total / T.cmp) * 100) + '%';
      }

      // Buttons
      var ok = allOk();
      if (el.id) el.id.value = v.id;
      if (el.add && !busy) {
        el.add.disabled = !ok;
        el.add.textContent = !ok ? 'Sold out' : (added ? 'Added to cart ✓' : 'Add to cart · ' + fm(T.total));
      }
      if (el.buy) el.buy.disabled = !ok;
      if (el.stickyAdd) {
        el.stickyAdd.disabled = !ok;
        el.stickyAdd.textContent = !ok ? 'Sold out' : (added ? 'Added ✓' : 'Add · ' + fm(T.total));
      }
      if (el.stickySub) {
        var parts = [mixText()];
        if (hasTiers) parts.push(n + ' ' + (n === 1 ? unitL : D.units));
        else if (S.qty > 1) parts.push('Qty ' + S.qty);
        if (PL.length) parts.push(isSub() ? 'Every ' + PL[S.plan].n : 'One-time');
        el.stickySub.textContent = parts.join(' · ');
      }

      document.dispatchEvent(new CustomEvent('unp:variant', { detail: { id: v.id, title: v.t } }));
      syncLabels(v.t);
    }

    // Events
    tierBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var oldN = N(), newN = i + 1;
        for (var j = oldN; j < newN; j++) S.picks[j] = S.picks[oldN - 1];
        S.tier = i;
        S.slot = newN > oldN ? oldN : Math.min(S.slot, newN - 1);
        say('');
        render();
      });
    });
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var i = Number(b.getAttribute('data-unp-chip')), sl = slot();
        S.picks[sl] = i;
        if (sl < N() - 1) S.slot = sl + 1;
        showHero(V[i]);
        go(0, true);
        if (N() === 1 && window.history && history.replaceState) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', V[i].id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        }
        say('');
        render();
      });
    });
    qa('[data-unp-pt]').forEach(function (b) {
      b.addEventListener('click', function () { S.buy = b.getAttribute('data-unp-pt'); render(); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          S.buy = S.buy === 'subscribe' ? 'onetime' : 'subscribe';
          render();
          var t = q('[data-unp-pt="' + S.buy + '"]'); if (t) t.focus();
        }
      });
    });
    planBtns.forEach(function (b) {
      b.addEventListener('click', function () { S.plan = Number(b.getAttribute('data-unp-plan')); render(); });
    });
    qa('[data-unp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.qty = Math.max(1, Math.min(99, S.qty + Number(b.getAttribute('data-unp-qty'))));
        if (el.qty) el.qty.value = S.qty;
        render();
      });
    });
    if (el.qty) el.qty.addEventListener('change', function () {
      S.qty = Math.max(1, Math.min(99, parseInt(el.qty.value, 10) || 1));
      el.qty.value = S.qty;
      render();
    });

    function say(t) { if (el.msg) el.msg.textContent = t; }
    function lineItems() {
      var pk = picks(), n = N(), grouped = {}, order = [], bid = n > 1 ? uid() : null;
      pk.forEach(function (i) {
        var id = V[i].id;
        if (!grouped[id]) { grouped[id] = 0; order.push(id); }
        grouped[id] += hasTiers ? 1 : S.qty;
      });
      return order.map(function (id) {
        var it = { id: id, quantity: grouped[id] };
        if (isSub()) it.selling_plan = PL[S.plan].id;
        if (bid) it.properties = { _bundle_id: bid, _bundle_size: String(n) };
        return it;
      });
    }
    function doAdd(after) {
      if (busy) return;
      if (!allOk()) { say('That option is sold out. Pick another.'); return; }
      busy = true;
      [el.add, el.stickyAdd].forEach(function (b) { if (b) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…'; } });
      var items = lineItems();
      var p = after === 'checkout' ? plainAdd(items) : addItems(items);
      p.then(function (r) {
        busy = false;
        [el.add, el.stickyAdd].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
        if (r && r.ok) {
          say('');
          if (after === 'checkout') { window.location.href = ROOT_URL + 'checkout'; return; }
          added = true; clearTimeout(addedT);
          addedT = setTimeout(function () { added = false; render(); }, 1600);
        } else {
          say((r && r.message) || 'That did not go through. Please try again.');
        }
        render();
      }, function () {
        busy = false;
        [el.add, el.stickyAdd].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
        say('That did not go through. Please try again.');
        render();
      });
    }
    var form = q('[data-unp-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(); });
    if (el.buy) el.buy.addEventListener('click', function () { doAdd('checkout'); });
    if (el.stickyAdd) el.stickyAdd.addEventListener('click', function () { doAdd(); });

    // Sticky bar: shows once the main buttons have scrolled off the top of the screen.
    var atc = q('[data-unp-atc]');
    if (el.sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var on = !e.isIntersecting && e.boundingClientRect.top < 0;
          el.sticky.classList.toggle('is-on', on);
          el.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (el.stickyAdd) el.stickyAdd.tabIndex = on ? 0 : -1;
        });
      }, { threshold: 0 }).observe(atc);
    }

    // Swatch colors on the server-rendered chips
    chips.forEach(function (b) {
      var d = b.querySelector('.unp-sw'); if (!d) return;
      var c = sw(V[Number(b.getAttribute('data-unp-chip'))].t);
      if (c) d.style.setProperty('--sw', c);
    });

    render();
  }

  /* ---------- Stack it with: quick add ---------- */
  function initQuick(scope) {
    (scope || document).querySelectorAll('[data-unp-quick]').forEach(function (b) {
      if (b.__unp) return; b.__unp = true;
      b.addEventListener('click', function () {
        var id = Number(b.getAttribute('data-unp-quick'));
        if (!id || b.getAttribute('aria-busy') === 'true') return;
        var label = b.textContent;
        b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…';
        addItems([{ id: id, quantity: 1 }]).then(function (r) {
          b.removeAttribute('aria-busy');
          b.textContent = r && r.ok ? 'Added ✓' : 'Try again';
          setTimeout(function () { b.textContent = label; }, 1600);
        }, function () { b.removeAttribute('aria-busy'); b.textContent = label; });
      });
    });
  }

  /* ---------- Reviews: Write a review opens the Loox widget form ---------- */
  function initReviews(scope) {
    (scope || document).querySelectorAll('[data-unp-write]').forEach(function (b) {
      if (b.__unp) return; b.__unp = true;
      b.addEventListener('click', function (e) {
        var app = document.getElementById('unp-loox');
        if (!app) return;
        e.preventDefault();
        app.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot(scope) {
    initLabels(scope);
    initMain((scope || document).querySelector('[data-unp-main]'));
    initQuick(scope);
    initReviews(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
